import React from "react";
import { format, getMonth, getYear } from "date-fns";

import { formatPrice } from "frontend/store/checkout";

// divides groups of statements by year
export const YearRow = ({ year }) => {
    return (
        <tr className="royalty-row-year">
            <td colSpan="8">{year}</td>
        </tr>
    );
};

export const ZeroEarningsCell = () => <td className="zero-revenue">--</td>;

const StatementRow = ({
    statementYear,
    statementMonth,
    freeIconCount,
    iconEarnings,
    purchaseIconCount,
    subscriptionEarnings,
    subscriptionDownloadCount,
    apiEarnings,
    apiDownloadCount,
    totalEarnings,
    totalPayout
}) => {
    return (
        <tr className="data">
            <td className="royalty-col-year">
                {format(new Date(statementYear, statementMonth), "MM/YY")}
            </td>

            <td>{freeIconCount}</td>

            {iconEarnings ? (
                <td>
                    ${formatPrice(iconEarnings)}
                    <br />
                    <span>
                        {purchaseIconCount}{" "}
                        {purchaseIconCount === 1 ? "icon" : "icons"}
                    </span>
                </td>
            ) : (
                <ZeroEarningsCell />
            )}

            {subscriptionEarnings ? (
                <td>
                    ${formatPrice(subscriptionEarnings)}
                    <br />
                    <span>
                        {subscriptionDownloadCount}{" "}
                        {subscriptionDownloadCount === 1 ? "icon" : "icons"}
                    </span>
                </td>
            ) : (
                <ZeroEarningsCell />
            )}

            {apiEarnings ? (
                <td>
                    ${formatPrice(apiEarnings)}
                    <br />
                    <span>
                        {apiDownloadCount}{" "}
                        {apiDownloadCount === 1 ? "icon" : "icons"}
                    </span>
                </td>
            ) : (
                <ZeroEarningsCell />
            )}

            {totalEarnings ? (
                <td className="royalty-col-total">
                    ${formatPrice(totalEarnings)}
                </td>
            ) : (
                <ZeroEarningsCell />
            )}

            {totalPayout ? (
                <td className="royalty-col-total">
                    ${formatPrice(totalPayout)}
                </td>
            ) : (
                <ZeroEarningsCell />
            )}
        </tr>
    );
};

const getTableMarkup = statements => {
    if (!statements.length) return null;

    let currentYear;
    const markup = [];

    statements.forEach(s => {
        const statementDate = new Date(s.royaltiesDate);
        const statementYear = statementDate.getUTCFullYear();

        if (statementYear !== currentYear) {
            currentYear = statementYear;
            markup.push(<YearRow key={currentYear} year={currentYear} />);
        }

        const statementMonth = statementDate.getUTCMonth();
        const { counts, earnings, payout, totalIconEarnings } = s;

        const subscriptionEarnings =
            earnings.subscription.iconEarnings +
            earnings.subscription.collectionIconEarnings;
        const subscriptionDownloadCount =
            counts.subscription.iconCount +
            counts.subscription.collectionIconCount;

        const apiEarnings = earnings.api.iconEarnings;
        const apiDownloadCount = counts.api.iconCount;

        const totalEarnings = totalIconEarnings || 0;
        const totalPayout = payout ? payout.earnings.icon : 0;

        const statementMarkup = (
            <StatementRow
                key={`${statementMonth}-${statementYear}`}
                statementYear={currentYear}
                statementMonth={statementMonth}
                freeIconCount={counts.free.iconCount}
                iconEarnings={earnings.purchase.iconEarnings}
                purchaseIconCount={counts.purchase.iconCount}
                subscriptionEarnings={subscriptionEarnings}
                subscriptionDownloadCount={subscriptionDownloadCount}
                apiEarnings={apiEarnings}
                apiDownloadCount={apiDownloadCount}
                totalEarnings={totalEarnings}
                totalPayout={totalPayout}
            />
        );

        markup.push(statementMarkup);
    });

    return markup;
};

const TableContents = ({ statements }) => {
    return <tbody>{getTableMarkup(statements)}</tbody>;
};

export default TableContents;
